/* ============
 * Axios
 * ============
 *
 * Promise based HTTP client for the browser and node.js.
 * Because Vue Resource has been retired, Axios will now been used
 * to perform AJAX-requests.
 *
 * https://github.com/mzabriskie/axios
 */

import Vue from "vue";
import axios from "axios";

export const HTTP = axios.create({
  baseURL: `/api/`,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/plugins/axios.ts